import apiService from './apiService';
import { Kol } from '../store/slices/kolSlice';

export const getKols = async (): Promise<Kol[]> => {
  const response = await apiService.get('/kols'); // 请确保 apiService 的 baseURL 已设置为 "https://kol-network-be.onrender.com/api"
  const data = response.data;
  // 返回 data.content 数组，data.content 中包含了 KOL 数据
  return data.content as Kol[];
};


export const getKolById = async (id: string): Promise<Kol> => {
  const response = await apiService.get<Kol>(`/kols/${id}`);
  return response.data;
};

export const createKol = async (kolData: Omit<Kol, 'id' | 'createdAt' | 'updatedAt'>): Promise<Kol> => {
  const response = await apiService.post<Kol>('/kols', kolData);
  return response.data;
};

export const updateKol = async (id: string, data: Partial<Kol>): Promise<Kol> => {
  const response = await apiService.put<Kol>(`/kols/${id}`, data);
  return response.data;
};


export const deleteKol = async (id: string): Promise<void> => {
  await apiService.delete(`/kols/${id}`);
};

export const submitKolApplication = async (applicationData: {
  name: string;
  email: string;
  instagramHandle: string;
  instagramFollowers: number;
  tiktokHandle?: string;
  tiktokFollowers?: number;
  categories: string[];
  notes?: string;
}): Promise<{ success: boolean; message: string }> => {
  const response = await apiService.post<{ success: boolean; message: string }>(
    '/kols/applications',
    applicationData
  );
  return response.data;
};